import React, { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';
import {
  collection,
  getCountFromServer,
  query,
  orderBy,
  where
} from 'firebase/firestore';
import { db } from 'config/firebase';
import { DECISIONS_COLLECTION } from '../config/rateShopConstants';
import { ConfirmModal, dateTime, LoadError, Loading } from './Common';

const SettingsConfirm = ({
  pending,
  draft,
  savedStores = [],
  latest,
  onHide,
  onConfirm
}) => {
  const [count, setCount] = useState(null);
  const [error, setError] = useState(null);
  const hours = Number(draft.sweep.lookbackHours);
  const storesChanged =
    JSON.stringify([...draft.storesInScope].sort()) !==
    JSON.stringify([...savedStores].sort());
  useEffect(() => {
    let active = true;
    setCount(null);
    setError(null);
    if (!(Number.isFinite(hours) && hours > 0)) {
      setError(
        new Error('Enter valid lookback hours before enabling live changes.')
      );
      return undefined;
    }
    const from = new Date(Date.now() - hours * 60 * 60 * 1000);
    getCountFromServer(
      query(
        collection(db, DECISIONS_COLLECTION),
        where('status', '==', 'dry-run'),
        where('decidedAt', '>=', from),
        orderBy('decidedAt', 'desc')
      )
    )
      .then(result => {
        if (active) setCount(result.data().count);
      })
      .catch(err => {
        if (active) setError(err);
      });
    return () => {
      active = false;
    };
  }, [hours]);
  return (
    <ConfirmModal
      show
      title="Switch to Live?"
      variant="warning"
      onHide={onHide}
      onConfirm={onConfirm}
      confirmDisabled={count === null || Boolean(error)}
      confirmLabel="Confirm change"
    >
      {count === null && !error && (
        <Loading label="Counting logged dry-run orders…" />
      )}
      <LoadError error={error} />
      {count !== null && (
        <p>
          {count} orders logged as dry-run in the last {hours}h may be written
          on the next runs (up to {draft.sweep.maxShipmentsPerRun} per run).
        </p>
      )}
      {storesChanged && (
        <Alert variant="warning">
          Your store selection has changed. This count uses previously logged
          orders, so it may include stores you removed and cannot show untested
          orders from stores you added.
        </Alert>
      )}
      {latest && (
        <p className="small text-muted">
          Latest run: {dateTime(latest.startedAt)} · {latest.mode} ·{' '}
          {latest.scanned ?? 0} scanned.
        </p>
      )}
      {pending.mode === 'live' && (
        <Alert variant="warning">
          Live mode can change the carrier, service, package and tags on orders
          in ShipStation.
        </Alert>
      )}
      <p className="mb-0">Save settings to apply this change.</p>
    </ConfirmModal>
  );
};

export default SettingsConfirm;
